import AutomatedProKitSerializer from "../automated-pro/KitSerializer";
import KitSerializer, { serializePriceMode } from "../rna-fish/KitSerializer";
import ManualProConsumerKitSerializer from "./ManualProConsumerKitSerializer";
var ManualProAdminKitSerializer = /** @class */ (function () {
    function ManualProAdminKitSerializer(scale, detectPresetScale, chromogenPresetScale) {
        var _this = this;
        this.scale = scale;
        this.detectPresetScale = detectPresetScale;
        this.chromogenPresetScale = chromogenPresetScale;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setDetect = function (state) {
            _this.detectState = state;
        };
        this.setBuffers = function (state) {
            _this.buffersState = state;
        };
        this.setChromogen = function (state) {
            _this.chromogenState = state;
        };
        this.serializeKit = function (comment, sampleType) {
            var probeSetComponent = null;
            var negativeControlProbe = false;
            if (_this.probeSetState) {
                var scaleValue = _this.probeSetState.scale.scaleValue;
                negativeControlProbe = _this.probeSetState.negativeControlProbe;
                probeSetComponent = {
                    _type: 'manual',
                    probeSet: KitSerializer
                        .serializeProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                    scaleValue: scaleValue,
                    channel: 1
                };
            }
            var detectComponent = null;
            if (_this.detectState) {
                detectComponent = AutomatedProKitSerializer.serializeDetect(_this.detectState, _this.detectPresetScale, _this.scale);
            }
            var chromogenComponent = null;
            if (_this.chromogenState) {
                chromogenComponent = AutomatedProKitSerializer.serializeChromogenComponent(_this.chromogenState, _this.chromogenPresetScale, _this.scale);
            }
            var buffersComponent = null;
            if (_this.buffersState) {
                buffersComponent = ManualProConsumerKitSerializer.serializeBuffers(_this.buffersState);
            }
            return {
                '_type': 'manual-pro',
                kit: {
                    sampleTypeId: sampleType.id,
                    probeSetComponent: probeSetComponent,
                    detectComponent: detectComponent,
                    buffersComponent: buffersComponent,
                    chromogenComponent: chromogenComponent,
                    comment: comment,
                    negativeControlProbe: negativeControlProbe,
                    starterKit: false,
                    priceModes: {
                        probeSetMode: serializePriceMode(_this.probeSetState ? _this.probeSetState.customPrice : undefined),
                        detectMode: serializePriceMode(_this.detectState ? _this.detectState.customPrice : undefined),
                        buffersMode: serializePriceMode(_this.buffersState ? _this.buffersState.customPrice : undefined),
                        chromogenMode: serializePriceMode(_this.chromogenState ? _this.chromogenState.customPrice : undefined),
                    }
                }
            };
        };
    }
    return ManualProAdminKitSerializer;
}());
export default ManualProAdminKitSerializer;
//# sourceMappingURL=ManualProAdminKitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProAdminKitSerializer.js
// module id = 1148
// module chunks = 0